module.exports = __webpack_public_path__ + "9ca3528cbd96811eccf5cce3421d7a5d.svg";